import { PlainMessage } from "@bufbuild/protobuf";
import { Section } from "@egocentric-systems/ts-apis/booking_gateway/v1/events_pb";
import { useMemo } from "react";
import { moneyToNumber } from "~/lib/utils";

export function useLegend(sections: PlainMessage<Section>[]) {
  return useMemo(() => {
    const seatPrices = sections.flatMap(
      (section) =>
        section.customSeats?.map((customSeat) => ({
          id: crypto.randomUUID(),
          priceGroupId: customSeat.priceGroupId,
          prices: customSeat.prices,
          priceGroupColor: customSeat.priceGroupColor,
        })) ?? [],
    );

    return [...sections, ...seatPrices]
      .filter((section) => !!section.prices?.length)
      .map((section) => {
        return {
          id: section.id,
          priceGoupId: section.priceGroupId,
          color: section.priceGroupColor,
          maxPrice: section.prices
            ?.map((price) => price.value)
            .reduce((maxPrice, currentPrice) =>
              moneyToNumber(maxPrice) > moneyToNumber(currentPrice)
                ? maxPrice
                : currentPrice,
            ),
        };
      })
      .filter(
        (section, i, arr) =>
          i ===
            arr.findIndex(
              (entry) => entry.priceGoupId === section.priceGoupId,
            ) && section.maxPrice !== undefined,
      )
      .toSorted(
        (a, b) => moneyToNumber(b.maxPrice) - moneyToNumber(a.maxPrice),
      );
  }, [sections]);
}
